import { useTranslation } from 'react-i18next';
import { useId } from 'react';

import CommonSwitch from '../../../components/common-switch/CommonSwitch';

import scss from './GlobalPercentageSwitch.module.scss';

function GlobalPercentageSwitch({ isGlobalPercentage, onChangeGlobalPercentage }) {
  const { t } = useTranslation('resonance');
  const id = useId();

  const handleChangeGlobalPercentage = () => {
    onChangeGlobalPercentage(!isGlobalPercentage);
  };

  return (
    <label htmlFor={id} className={scss.switchLabel}>
      <span>{t('globalPercentage')}:</span>
      <CommonSwitch name={id} id={id} checked={isGlobalPercentage} onChange={handleChangeGlobalPercentage} />
    </label>
  );
}

export default GlobalPercentageSwitch;
